export default {
  MEMBER_ADDING_PUBLIC_KEY_TAG: "MemberAddingPublicKeyTag",
  FIRST_MEMBER_PUBLIC_KEY_TAG: "FirstMemberPublicKeyTag",
  MEMBER_PUBLIC_KEY_TAG: "MemberPublicKeyTag",
  GROUP_CREATOR_PUBLIC_KEY_TAG: "GroupCreatorPublicKeyTag",
  MEMBER_SIGNING_PUBLIC_KEY_TAG: "MemberSigningPublicKeyTag",
  ADMIN_PUBLIC_KEY_TAG: "AdminPublicKeyTag",
  ADMIN_SIGNING_PUBLIC_KEY_TAG: "AdminSigningPublicKeyTag",
  GHOST_MEMBER_PUBLIC_KEY_TAG: "GhostMemberPublicKeyTag",
  // The ghost member's ENCRYPTION public key chain. Distinct from the tag above so a layer
  // says which half of the split pair it carries; both verify with the ghost SIGNING key,
  // because that is what produced the signature.
  GHOST_MEMBER_ENCRYPTION_PUBLIC_KEY_TAG: "GhostMemberEncryptionPublicKeyTag",
  BAYUN_SERVER_PUBLIC_KEY_TAG: "BayunServerPublicKeyTag",
  MEMBER_APP_PUBLIC_KEY_TAG: "MemberAppPublicKeyTag",
  MEMBER_APP_SIGNING_PUBLIC_KEY_TAG: "MemberAppSigningPublicKeyTag",
  USER_PUBLIC_KEY_TAG: "UserPublicKeyTag",
  USER_SIGNING_PUBLIC_KEY_TAG: "UserSigningPublicKeyTag",
  ORG_PUBLIC_KEY_TAG: "OrgPublicKeyTag",
  GROUP_PUBLIC_KEY_TAG: "GroupPublicKeyTag",
  BACKDOOR_PUBLIC_KEY_TAG: "BackdoorPublicKeyTag",
  BACKDOOR_SIGNING_PUBLIC_KEY_TAG: "BackdoorSigningPublicKeyTag",
  AUTHORIZATION_APP_PUBLIC_KEY_TAG: "AuthorizationAppPublicKeyTag",
  AUTHORIZATION_APP_SIGNING_PUBLIC_KEY_TAG: "AuthorizationAppSigningPublicKeyTag",
  APPROVING_MEMBER_PUBLIC_KEY_TAG: "ApprovingMemberPublicKeyTag",
  MEMBER_CREATION_APP_PUBLIC_KEY_TAG: "MemberCreationAppPublicKeyTag",
  MEMBER_CREATION_APP_SIGNING_PUBLIC_KEY_TAG: "MemberCreationAppSigningPublicKeyTag",
  ACCESS_APP_SIGNING_PUBLIC_KEY_TAG: "AccessAppSigningPublicKeyTag",
  // No resolver branch in getSignatureVerificationPublicKey, so a signature carrying this tag
  // always fails verification (fail-closed). Kept for wire compatibility with the server's tag
  // vocabulary; add a resolver before relying on it.
  ORG_CREATION_APP_SIGNING_PUBLIC_KEY_TAG: "OrgCreationAppSigningPublicKeyTag",
};
